export enum Nem {
    Ferfi = 1,
    No = 2,
    Ismeretlen = 9
}
